import EventEmitter from 'eventemitter3';

const eventEmitter = new EventEmitter();
const Emitter = eventEmitter;

export default Emitter;
